<template>
  <div class="content">
    <div class="background-index">
      <div class="top-title common">马上就办 最多跑一趟</div>
      <div class="middle-title common">Right Away and All at Once</div>
      <div class="bottom-operator common">
        <BreadCrumbs />
      </div>
      <div class="common content-operator sss-1">
        <div class="common" style="width: 940px" @mouseleave="
            () => {
              setTarget('');
            }
          ">
          <div class="content-middle">
            <img src="../../../assets/images/bg2.png" alt="遮罩图片" />
            <div class="mask-title">
              <p style="border-left: 1px solid #e5e5e5; border-right: 1px solid #e5e5e5;">窗口业务</p>
              <p style="border-left: 1px solid #e5e5e5; border-right: 1px solid #e5e5e5;">Window Service</p>
              <p style="height: 42px; border-left: 1px solid #e5e5e5; border-right: 1px solid #e5e5e5;">&nbsp;</p>
            </div>
            <div v-for="item in list" :key="item" :class="
                getFocus(item.ename) === 'focus'
                  ? 'focus-list list-content'
                  : 'list-content'
              " @mouseenter.stop="
                () => {
                  setTarget(item.ename);
                }
              ">
              <template>
                <img v-if="item.icon" :src="`${
                    item[getFocus(item.ename) === 'focus' ? 'iconf' : 'icon']
                  }`" alt="" />
                <div class="nav-box">
                  <p>{{ item.name }}</p>
                  <p>{{ item.ename }}</p>
                </div>
              </template>
            </div>
          </div>
          <div class="content-right">
            <template v-if="!currentEname">
              <!-- <div style="transform: translateX(-48px) translateY(-20px)">
                <img :src="imgs && imgs[0] && imgs[0].fileHttpUrl" alt="" />
              </div> -->
              <a-carousel :dots="false" style="width: 799px;height: 535px; transform: translateX(-48px) translateY(-21px)" autoplay ref="swiper">
                <div class="swiper-box" v-for="item in imgs" :key="item.fileCode">
                  <img :src="item.fileHttpUrl">
                </div>
              </a-carousel>
              <div class="arrow-swiper">
                <p @click="choose(true)"><img src="../../../assets/images/icon_carousel_left_white.png"></p>
                <p @click="choose(false)"><img src="../../../assets/images/icon_carousel_right_white.png"></p>
              </div>
            </template>
            <template v-else>
              <div class="left-box" v-for="item in mapItem[currentEname]" :key="item.name" @click.stop="open(item)">
                <div class="title">{{ item.name }}</div>
                <div @click.stop="open(citem)" class="desc" v-for="(citem) in item.children" :key="citem">
                  {{ citem.name }}
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const list = [
  {
    name: "日本签证",
    ename: "Japan Visas",
    icon: require("../../../assets/images/icon_window_service_japan_visa_.png"),
    iconf: require("../../../assets/images/icon_window_service_japan_visa.png"),
  },
  {
    name: "领事认证",
    ename: "Consular Authentication",
    icon: require("../../../assets/images/icon_window_service_consular_certification.png"),
    iconf: require("../../../assets/images/icon_window_service_consular_certification_.png"),
  },
  {
    name: "翻译服务",
    ename: "Translation Services",
    icon: require("../../../assets/images/icon_window_service_translation_documents.png"),
    iconf: require("../../../assets/images/icon_window_service_translation_documents_.png"),
  },
  {
    name: "出国服务",
    ename: "Overseas Services",
    icon: require("../../../assets/images/icon_window_service_air_services.png"),
    iconf: require("../../../assets/images/icon_window_service_air_services_.png"),
  },
  {
    name: "外企服务",
    ename: "Services for Foreign Enterprises",
    icon: require("../../../assets/images/icon_window_service_foreign.png"),
    iconf: require("../../../assets/images/icon_window_service_foreign_.png"),
  },
  // { name: '', ename: '123' },
];
import BreadCrumbs from "@/components/home/breadCrumbs";
import { getWindowService, getwindowServicePhoto } from "@/api/service.js";
import { getFileDetails } from "@/api/file.js";
const mapItem = {
  "Japan visa": [
    {
      name: "表格下载",
      type: "router",
      url: "/announcement?moduleCode=RES8283FC5BA5CE97C&type=contentDownload&linkname=出国签证/表格下载/详情&name=表格下载",
      children: [
        {
          name: "问答卷",
          type: "router",
          url: "/announcement?type=contentAnnounce&moduleCode=RESB07757FD334EBBF&name=问答卷&linkname=出国签证%2F表格下载%2F问答卷%2F详情",
        },
        {
          name: "其他表格",
          type: "router",
          url: "/announcement?type=contentAnnounce&moduleCode=RES4C3AD82FC9DD0AD&name=其他表格&linkname=出国签证%2F表格下载%2F其他表格%2F详情",
        },
      ],
    },
    {
      name: "所需材料",
      type: "router",
      url: "/announcement?moduleCode=RES8CD7965C003AEFF&type=contentAnnounce&linkname=出国签证/所需材料/详情&name=所需材料",
      children: [
        {
          name: "探亲访友",
          type: "router",
          url: "/announcement?moduleCode=RES8CD7965C003AEFF&type=contentAnnounce&linkname=出国签证/探亲访友/详情&name=探亲访友",
        },
        {
          name: "长期居留",
          type: "router",
          url: "/announcement?moduleCode=RES5EC21A855973A8F&type=contentAnnounce&linkname=出国签证/长期居留/详情&name=长期居留",
        },
        {
          name: "短期商务",
          type: "router",
          url: "/announcement?moduleCode=RES44BB72B5E2B118D&type=contentAnnounce&linkname=出国签证/短期商务/详情&name=短期商务",
        },
        {
          name: "其他签证",
          type: "router",
          // url: "/announcement?moduleCode=RES8CD7965C003AEFF&type=contentAnnounce&linkname=出国签证/其他/详情&name=其他&typeCode=TYPE_43C5F874DDD4592",
          url: "/announcement?moduleCode=RES23BC34D0C6B80F8&type=contentAnnounce&linkname=出国签证/其他签证/详情&name=其他签证",
        },
      ],
    },
    {
      name: "办理流程",
      type: "html",
      // url: `/htmlContent?type=contentAnnounce&contentCode=RES12307B4DE5174A2&name=办理流程&linkname=办理流程/详情`,
      children: [
        {
          name: "日本签证办理流程",
          type: "router",
          url: "/htmlContent?type=contentAnnounce&contentCode=RES12307B4DE5174A2&name=办理流程&linkname=办理流程/详情",
        },
      ]
    },
  ],
  "Consular certification": [
    {
      name: "邮寄办理",
      type: "none",
      children: [
        {
          name: "办理步骤",
          type: "html",
          url: `/htmlContent?type=contentAnnounce&contentCode=RES005D60C01B8AD9B&name=办理步骤&linkname=邮寄办理/办理步骤/详情`,
        },
        {
          name: "认证费用",
          type: "self",
          url: `/selfComponents?name=认证费用&linkname=邮寄办理/认证费用/详情&type=1`,
        },
        {
          name: "认证材料",
          type: "self",
          url: `/selfComponents?name=认证材料&linkname=邮寄办理/认证材料/详情&type=2`,
        },
      ],
    },
    {
      name: "窗口办理",
      type: "none",
      children: [
        {
          name: "办理步骤",
          type: "html",
          url: `/htmlContent?type=contentAnnounce&contentCode=RESE6308ADD56E6DA9&name=办理步骤&linkname=窗口办理/办理步骤/详情`,
        },
        {
          name: "认证费用",
          type: "self",
          url: `/selfComponents?name=认证费用&linkname=邮寄办理/认证费用/详情&type=1`,
        },
        {
          name: "认证材料",
          type: "self",
          url: `/selfComponents?name=认证材料&linkname=邮寄办理/认证材料/详情&type=2`,
        },
      ],
    },
    {
      name: "一站式办理",
      type: "self",
      children: [
        {
          name: "公证认证“一站式”服务",
          type: "self",
          url: `/selfComponents?name=认证费用&linkname=一站式办理/公证认证“一站式”服务/详情&type=3`,
        },
      ],
    },
    {
      name: "远程视频",
      type: "none",
      children: [{ name: "海外远程视频公证服务", type: "none" }],
    },
  ],
  "Translation Services": [
    {
      name: "翻译服务",
      type: "none",
      children: [
        {
          name: "口译服务",
          type: "html",
          url: `/htmlContent?type=contentNews&contentCode=RESF27EF67D23ECEAC&name=口译服务&linkname=翻译服务/口译服务/详情`,
        },
        {
          name: "文书笔译",
          type: "html",
          url: `/htmlContent?type=contentNews&contentCode=RES550BE105F1433B6&name=文书笔译&linkname=翻译服务/文书笔译/详情`,
        },
      ],
    },
    {
      name: "国际会议",
      type: "none",
      children: [
        {
          name: "同传设备",
          type: "html",
          url: `/htmlContent?type=contentNews&contentCode=RESDF11AAACE6BCD79&name=同传设备&linkname=国际会议/同传设备/详情`,
        },
        {
          name: "云视频会议",
          type: "html",
          url: `/htmlContent?type=contentNews&contentCode=RES666C2662A191179&name=云视频会议&linkname=国际会议/云视频会议/详情`,
        },
      ],
    },
    {
      name: "接待培训",
      type: "none",
      children: [
        {
          name: "接待服务",
          type: "html",
          url: "/htmlContent?type=contentNews&contentCode=RES844C69E26C521F2&name=接待服务&linkname=国际会议/接待培训/详情"
        },
        {
          name: "涉外培训",
          type: "html",
          url: "/htmlContent?type=contentNews&contentCode=RES87481AA8C45F3D4&name=涉外培训&linkname=国际会议/接待培训/详情"
        },
      ],
    },
  ],
  "Overseas Services": [
    {
      name: "境外服务",
      type: "none",
      children: [
        {
          name: "境外接待",
          type: "html",
          url: `/htmlContent?type=contentNews&contentCode=RESC6DD2AC3CDB40AE&name=境外接待&linkname=境外服务/境外接待/详情`,
        },
        { name: "境外保险", type: "none" },
      ],
    },
    {
      name: "航空票务",
      type: "none",
      children: [
        {
          name: "航空订票",
          type: "html",
          url: `/htmlContent?type=contentNews&contentCode=RES7B7CE3B1EBDBB06&name=航空订票&linkname=航空票务/航空订票/详情`,
        },
        {
          name: "航空保险",
          type: "html",
          url: `/htmlContent?type=contentNews&contentCode=RESD9B2E8A900696C7&name=航空保险&linkname=航空票务/航空保险/详情`,
        },
      ],
    },
    {
      name: "APEC商务旅行卡",
      type: "none",
      children: [
        {
          name: "内容简介",
          type: "self",
          url: `/selfComponents?name=APEC商务旅行卡&linkname=APEC商务旅行卡/内容简介/详情&type=4`,
        },
        {
          name: "网上服务",
          type: "link",
          url: `https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?unid=3030B12463CC1D45D71FE805176BA846&infoType=1`,
        },
      ],
    },
    {
      name: "领事保护",
      type: "none",
      children: [
        {
          name: "海外领事保护信息",
          type: "link",
          url: `http://wb.fujian.gov.cn/ywxx/hwlsfwbhqzxt/`,
        },
      ],
    },
    {
      name: "国别概况",
      type: "none",
      children: [
        {
          name: "了解目的地信息",
          type: "link",
          url: `http://cs.mfa.gov.cn/zggmcg/ljmdd/`,
        },
      ],
    },
  ],
  "Services for Foreign Enterprises": [
    {
      name: "企业服务",
      type: "none",
      children: [
        {
          name: "人事管理",
          type: "router",
          url: "/htmlContent?contentCode=RES1FBF07DCDD51218&type=contentAnnounce&name=人事管理&linkname=外企服务/人事管理/详情",
        },
        {
          name: "外包服务",
          type: "router",
          url: "/htmlContent?contentCode=RES6A5C29ABB915405&type=contentAnnounce&name=业务外包&linkname=外企服务/业务外包/详情",
        },
        {
          name: "外籍服务",
          type: "router",
          url: "/htmlContent?contentCode=RESF4FE5B0BEA24A6A&type=contentAnnounce&name=外籍服务&linkname=外企服务/外籍服务/详情",
        },
        {
          name: "福利定制",
          type: "router",
          url: "/htmlContent?contentCode=RES1DE485AE805751F&type=contentAnnounce&name=福利定制&linkname=外企服务/福利定制详情",
        },
      ],
    },
    {
      name: "员工服务",
      children: [
        {
          name: "办事指南",
          type: "router",
          url: "/announcement?moduleCode=RES7647CE3C708E3B8&type=contentAnnounce&linkname=员工服务/服务指南/详情&name=服务指南",
        },
        {
          name: "表格下载",
          type: "router",
          url: "/announcement?moduleCode=RES22D560EF174EDA7&type=contentAnnounce&linkname=员工服务/表格下载/详情&name=表格下载",
        },
      ],
    },
    {
      name: "政策导航",
      children: [
        {
          name: "社保",
          type: "router",
          url: "/announcement?moduleCode=RESC522AC0AC50AB33&type=contentAnnounce&linkname=政策导航/社保/详情&name=社保",
        },
        {
          name: "医保",
          type: "router",
          url: "/announcement?moduleCode=RESCF5A69E855E638C&type=contentAnnounce&linkname=政策导航/医保/详情&name=医保",
        },
        {
          name: "公积金",
          type: "router",
          url: "/announcement?moduleCode=RESE3584DAC7A49E11&type=contentAnnounce&linkname=政策导航/公积金/详情&name=公积金",
        },
        {
          name: "其他",
          type: "router",
          url: "/announcement?moduleCode=RES93CDDCB0AAC2FEB&type=contentAnnounce&linkname=政策导航/其他/详情&name=其他",
        },
      ],
    },
  ],
};
export default {
  name: "window-service",
  components: {
    BreadCrumbs,
  },
  data () {
    return {
      list,
      mapItem,
      currentEname: "",
      imgs: [],
    };
  },
  computed: {
    getFocus () {
      return function (val) {
        return this.currentEname === val ? "focus" : "";
      };
    },
  },
  created () {
    window.scrollTo(0, 0)
    this.getList();
  },
  methods: {
    open (item) {
      if (
        item.type === "router" ||
        item.type === "html" ||
        item.type === "self"
      ) {
        item.url && this.pushRouter(item.url);
      }
      if (item.type === "link") {
        item.url && window.open(item.url);
      }
    },
    getList () {
      getWindowService().then(async (res) => {
        let list = this._.get(res, "data.records", []);
        this.imgs = JSON.parse(JSON.stringify([]));
        for (let i of list) {
          const resI = await getwindowServicePhoto(i.picCode, i.tenantCode);
          const img = await getFileDetails(
            this._.get(resI, "data.appCode", ""),
            this._.get(resI, "data.tenantCode"),
            [
              ...this._.get(resI, "data.contentPicFileDtoList", []).map(
                (item) => item.fileCode
              ),
            ]
          );
          this.imgs.push(...Object.values(this._.get(img, "data")));
        }
      });
    },
    changeSwiper (name) {
      this.$refs.swiper && this.$refs.swiper[name]();
    },
    setTarget (ename) {
      // if (!ename) return
      this.currentEname = ename;
    },
    choose (isprev) {
      if (isprev) {
        this.$refs && this.$refs.swiper.prev()
      } else {
        this.$refs && this.$refs.swiper.next()
      }
    },
  },
};
</script>

<style scoped lang='less'>
.content {
  width: 100%;
  height: 1000px;
  margin-bottom: 30px;
}
.background-index {
  height: 190px;
  width: 100%;
  position: absolute;
  index: -1;
  background-image: url("../../../assets/images/icon_window_service_bg.png");
  // background-size: 100% 100%;
  background-repeat: no-repeat;
  // background-position: center;
}
.top-title {
  width: 100%;
  height: 65px;
  font-size: 55px;
  font-family: Alibaba PuHuiTi;
  font-weight: bold;
  color: #ffffff;
  line-height: 30px;
  top: 60px;
}
.middle-title {
  width: 736px;
  height: 31px;
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 30px;
  top: 130px;
}
.common {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.bottom-operator {
  width: 100%;
  height: 120px;
  top: 190px;
  left: 0;
  transform: translateX(0);
  background: white;
}
.content-operator {
  top: 290px;
  background: white;
  height: 480px;
  width: 100%;
  min-width: 1366px;
  > div {
    width: 1140px;
    display: flex;
  }
}
.content-left {
  margin-left: 200px;
  width: 106px;
  display: flex;
  flex-direction: column;
  margin-bottom: 87px;
  justify-content: flex-end;
  padding-right: 10px;
  li {
    background: #cbb486;
    list-style: none;
    height: 80px;
    line-height: 80px;
  }
  li.focus {
    background: white;
  }
}
.content-middle {
  width: 319px;
  height: 620px;
  position: relative;

  img {
    margin-bottom: 24px;
  }
  .mask-title {
    position: absolute;
    top: 21px;
    left: 0;
    width: 100%;
    p {
      margin: 0;
      padding: 0;
      text-align: center;
      width: 100%;
    }
    p:nth-of-type(1) {
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
      text-align: center;
    }
    p:nth-of-type(2) {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
    }
  }
}
.list-content:not(:last-of-type) {
  border-left: 1px solid #e5e5e5;
  border-right: 1px solid #e5e5e5;
  border-top: 1px solid #e5e5e5;
}
.list-content:last-of-type {
  border: 1px solid #e5e5e5;
}
.list-content {
  cursor: pointer;
  display: flex;
  padding: 12px 0;
  height: 84.5px;
  img {
    width: 32px;
    height: 32px;
    transform: translateY(10px);
    margin: 0 29px 0 24px;
  }
  .nav-box {
    p {
      margin: 0;
      padding: 0;
      text-align: left;
    }
    p:nth-of-type(1) {
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 24px;
      padding-top: 7px;
    }
    p:nth-of-type(2) {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #7f7f7f;
      line-height: 14px;
      padding-top: 10px;
    }
  }
}
.focus-list {
  background: #cbb486;
  .nav-box {
    p:nth-of-type(2) {
      color: white;
    }
    p:nth-of-type(1) {
      color: white;
    }
  }
}
.content-right {
  width: 620px;
  height: 536px;
  margin-top: 20px;
  margin-left: -1px;
  position: relative;
  padding: 20px;
  padding-left: 47px;
  border: 1px solid #e8e8e8;
}
.swiper {
  height: 587px;
  img {
    width: 100%;
    height: 100%;
  }
}
.arrow-swiper {
  cursor: pointer;
  p {
    position: absolute;
    top: 225px;
    width: 42px;
    height: 70px;
    background: #000000;
    opacity: 0.8;
    line-height: 70px;
    img {
      width: 20px;
      height: 34px;
    }
  }
  p:first-of-type {
    left: 0%;
  }
  p:last-of-type {
    right: -180px;
  }
}
.arrow {
  width: 42px;
  height: 70px;
  background: #000000;
  opacity: 0.64;
  position: absolute;
  font-size: 30px;
  line-height: 70px;
  cursor: pointer;
}
.swiper-box {
  width: 799px;
  height: 535px;
  background: #dcdcdc;
  text-align: center;
  position: relative;
  img {
    display: inline-block;
    width: 100%;
    height: 100%;
  }
}
.right-ar {
  top: 45%;
  right: 0;
}
.left-ar {
  top: 45%;
  left: 0;
}
.content-right {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}
.left-box {
  width: 50%;
}
.title {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  padding: 20px 0;
  // cursor: pointer;
  cursor: default;
}
// .title:hover {
//   color: #cbb486;
// }
.desc {
  text-align: left;
  // text-indent: 10px;
  line-height: 30px;
  cursor: pointer;
  font-size: 16px;
  font-family: "微软雅黑";
}
.desc:hover {
  color: #cbb486;
}
</style>



// WEBPACK FOOTER //
// src/components/content/windowService/index.vue